module.exports = __webpack_public_path__ + "media/promo/velle/images/leaves-77d6f6ccaba97e899b285c3e1f7d9a1c.png";